import React from "react";
import { Link } from "react-router-dom";

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-red-50 px-4 py-12 dark:bg-gray-900">
      <div className="mx-auto max-w-4xl rounded-xl bg-white/90 p-6 shadow-md backdrop-blur dark:bg-gray-800/90">
        <h1 className="mb-6 text-3xl font-bold text-gray-900 dark:text-white">
          Datenschutzerkl&auml;rung
        </h1>

        <div className="space-y-4 text-gray-700 dark:text-gray-200">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Bitte Platzhalter mit Ihren echten Angaben ersetzen. Diese Vorlage
            bietet die &uuml;blichen Pflichtangaben (Art. 13/14 DSGVO).
          </p>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Verantwortlicher
            </h2>
            <p>
              Colin Frugte
              <br />
              Hartwig-Hesse-Straße 27
              <br />
              20257 Hamburg
              <br />
              E-Mail: help@jingolin.com
              <br />
              Telefon: +49 (0) 000 000000
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Zwecke und Rechtsgrundlagen der Verarbeitung
            </h2>
            <ul className="list-disc space-y-2 pl-6">
              <li>
                Bereitstellung der Website und App (Art. 6 Abs. 1 lit. f DSGVO)
              </li>
              <li>
                Nutzer-Accounts, Login per Magic Link, Gruppenerstellung und
                Teilnahme (Art. 6 Abs. 1 lit. b DSGVO)
              </li>
              <li>
                Kommunikation (z. B. E-Mail-Versand) und Support (Art. 6 Abs. 1
                lit. b, f DSGVO)
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Kategorien von Daten
            </h2>
            <ul className="list-disc space-y-2 pl-6">
              <li>Bestandsdaten: Name, E-Mail, ggf. Adresse</li>
              <li>
                Nutzungsdaten: Logins, Gruppen-Teilnahme, Wunschlisten-Einträge
              </li>
              <li>
                Protokolldaten: IP-Adresse, Zeitstempel, User-Agent
                (Server-Logs)
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Empf&auml;nger
            </h2>
            <p>
              Interne Teammitglieder und ggf. Dienstleister (z. B. Hosting,
              E-Mail-Provider). Mit Auftragsverarbeitern bestehen entsprechende
              Vertr&auml;ge gem. Art. 28 DSGVO.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Speicherung und L&ouml;schung
            </h2>
            <p>
              Daten werden nur so lange gespeichert, wie es f&uuml;r die Zwecke
              erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
              Anschließend L&ouml;schung oder Anonymisierung.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Drittlands&uuml;bermittlung
            </h2>
            <p>
              Falls Dienste außerhalb der EU/EWR genutzt werden (z. B. Cloud
              Provider), erfolgt dies auf Basis geeigneter Garantien (Art. 46
              DSGVO, z. B. EU-Standardvertr&auml;ge). Bitte konkret benennen,
              falls zutreffend.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Cookies und &auml;hnliche Technologien
            </h2>
            <p>
              Wir nutzen technisch notwendige Cookies (z. B. Session/Token).
              Optionale Cookies oder Tracking-Tools werden nur mit Einwilligung
              verwendet (Art. 6 Abs. 1 lit. a DSGVO, &sect; 25 TTDSG). Bitte
              erg&auml;nzen, falls Analysetools oder Marketing-Tracker
              eingesetzt werden.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Ihre Rechte
            </h2>
            <p>
              Sie haben Rechte auf Auskunft, Berichtigung, L&ouml;schung,
              Einschr&auml;nkung, Daten&uuml;bertragbarkeit sowie Widerspruch
              (Art. 15-21 DSGVO). Sie k&ouml;nnen erteilte Einwilligungen
              jederzeit widerrufen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Beschwerderecht
            </h2>
            <p>
              Sie k&ouml;nnen sich bei einer Datenschutz-Aufsichtsbeh&ouml;rde
              beschweren, z. B. bei der f&uuml;r Ihren Wohnort zust&auml;ndigen
              Beh&ouml;rde.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Kontakt f&uuml;r Datenschutz-Anfragen
            </h2>
            <p>
              E-Mail: help@jingolin.com
              <br />
              Bitte hier den verantwortlichen Kontakt benennen.
            </p>
          </section>

          <p className="text-sm text-gray-500 dark:text-gray-400">
            Zur&uuml;ck zur{" "}
            <Link to="/" className="text-rose-600 underline">
              Startseite
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
